export default __webpack_public_path__ + "static/media/day1.7137389d.svg";